import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import HTTPMethod from 'http-method-enum';
import { USER_FILE } from '@yoweb/utils/constants/formData';
import { API_USER_IMAGE } from '@poplar/constants/routes';
export var personNameWithFallback = function personNameWithFallback(person) {
  if (!person) {
    return;
  }

  return person.preferredName || person.givenName;
};
export var convertPostalAddressToUserAddress = function convertPostalAddressToUserAddress(postalAddress, defaultCountry) {
  var _postalAddress$addres, _postalAddress$addres2, _postalAddress$locali, _postalAddress$admini, _postalAddress$region, _postalAddress$postal;

  return {
    street1: (_postalAddress$addres = postalAddress === null || postalAddress === void 0 ? void 0 : postalAddress.addressLinesList[0]) !== null && _postalAddress$addres !== void 0 ? _postalAddress$addres : '',
    street2: (_postalAddress$addres2 = postalAddress === null || postalAddress === void 0 ? void 0 : postalAddress.addressLinesList[1]) !== null && _postalAddress$addres2 !== void 0 ? _postalAddress$addres2 : '',
    city: (_postalAddress$locali = postalAddress === null || postalAddress === void 0 ? void 0 : postalAddress.locality) !== null && _postalAddress$locali !== void 0 ? _postalAddress$locali : '',
    region: (_postalAddress$admini = postalAddress === null || postalAddress === void 0 ? void 0 : postalAddress.administrativeArea) !== null && _postalAddress$admini !== void 0 ? _postalAddress$admini : '',
    country: (_postalAddress$region = postalAddress === null || postalAddress === void 0 ? void 0 : postalAddress.regionCode) !== null && _postalAddress$region !== void 0 ? _postalAddress$region : defaultCountry,
    postalCode: (_postalAddress$postal = postalAddress === null || postalAddress === void 0 ? void 0 : postalAddress.postalCode) !== null && _postalAddress$postal !== void 0 ? _postalAddress$postal : ''
  };
};
var FORM_FILENAME = 'profile picture';
export var changeProfilePicture = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(image, onChanged) {
    var formData, res, _ref2, profilePictureUrl;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            formData = new FormData();
            formData.append(USER_FILE, image, FORM_FILENAME);
            _context.next = 4;
            return fetch(API_USER_IMAGE, {
              method: HTTPMethod.POST,
              body: formData
            });

          case 4:
            res = _context.sent;

            if (res.ok) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", false);

          case 7:
            _context.next = 9;
            return res.json();

          case 9:
            _ref2 = _context.sent;
            profilePictureUrl = _ref2.profilePictureUrl;
            onChanged(profilePictureUrl);
            return _context.abrupt("return", true);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function changeProfilePicture(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();